export enum BloodGroups {
  ABNegative = "ABNegative",
  ABPositive = "ABPositive",
  ANegative = "ANegative",
  APositive = "APositive",
  BNegative = "BNegative",
  BPositive = "BPositive",
  ONegative = "ONegative",
  OPositive = "OPositive",
}

export enum Gender {
  FEMALE = "FEMALE",
  MALE = "MALE",
  OTHER = "OTHER",
}

export enum Relation {
  BROTHER = "BROTHER",
  COUSIN = "COUSIN",
  DAUGHTER = "DAUGHTER",
  FATHER = "FATHER",
  GRANDDAUGHTER = "GRANDDAUGHTER",
  GRANDFATHER = "GRANDFATHER",
  GRANDMOTHER = "GRANDMOTHER",
  GRANDSON = "GRANDSON",
  HUSBAND = "HUSBAND",
  ME = "ME",
  MOTHER = "MOTHER",
  OTHER = "OTHER",
  SISTER = "SISTER",
  SON = "SON",
  WIFE = "WIFE",
}

export enum PATIENT_ADDRESS_TYPE {
  HOME = "HOME",
  OFFICE = "OFFICE",
  OTHER = "OTHER",
}

export enum CouponApplicable {
  APPLIED = "APPLIED",
  ITEM_AT_HIGHER_DISCOUNT = "ITEM_AT_HIGHER_DISCOUNT",
  NOT_APPLICABLE = "NOT_APPLICABLE",
}

export enum PLAN_ID {
  CIRCLEPlan = "CIRCLEPlan",
}

export enum CART_SOURCE {
  CARE_PERSONA = "CARE_PERSONA",
  NA = "NA",
  WHATSAPP_REMINDER = "WHATSAPP_REMINDER",
  RE_ORDER_REMINDER = "RE_ORDER_REMINDER",
}

export enum PRESCRIPTION_ADDED_BY {
  AUTO_UPLOAD = "AUTO_UPLOAD",
  PATIENT = "PATIENT",
}

export enum FEEDBACK {
  HC_REMOVES_COUPON = "HC_REMOVES_COUPON",
  NA = "NA",
  REMOVE_HC = "REMOVE_HC",
}

export enum OPT_SOURCE {
  APOLLO_PHARMACY_STORE = "APOLLO_PHARMACY_STORE",
  CALL_CENTER = "CALL_CENTER",
  CAMPAIGN = "CAMPAIGN",
  CAMPS = "CAMPS",
  CLINIC = "CLINIC",
  COMMUNITY_CHAMPION = "COMMUNITY_CHAMPION",
  OMT_TEAM = "OMT_TEAM",
  PARTNER = "PARTNER",
  WHATSAPP = "WHATSAPP",
}

export enum PrescriptionType {
  CONSULT = "CONSULT",
  LATER = "LATER",
  NA = "NA",
  UPLOADED = "UPLOADED",
}

export enum CorporateStatus {
  APPLICABLE = "APPLICABLE",
  APPLIED = "APPLIED",
  NOT_APPLICABLE = "NOT_APPLICABLE",
}

export enum CartNudgeAction {
  CLOSE = "CLOSE",
  PROCEED = "PROCEED",
}

export enum CART_PAGE_CLICK {
  COUPONS = "COUPONS",
  DELIVERY = "DELIVERY",
}

export interface AddressInput {
  coordinate?: CoordinateInput | null;
  id?: string | null;
  zipcode?: string | null;
}

export interface BasePlanDetails {
  planId?: PLAN_ID | null;
  subPlanId?: string | null;
}

export interface CartInputDataV2 {
  address?: AddressInput | null;
  bankOffer?: boolean | null;
  cartSource?: CART_SOURCE | null;
  coupon?: string | null;
  feedback?: FEEDBACK | null;
  isHCPreferred?: boolean | null;
  isReminderSet?: boolean | null;
  medicineOrderCartLineItems?: (CartLineItemInputV2 | null)[] | null;
  patientId: any;
  prescriptionDetails?: (CartPrescriptionInputV2 | null)[] | null;
  prescriptionType?: PrescriptionType | null;
  subscription?: CartSubscriptionInputV2 | null;
  contactNumber?: string;
}

export interface CartLineItemInputV2 {
  isReminderSet?: boolean | null;
  medicineSKU: string;
  quantity: number;
  reminderDuration?: number | null;
  skuToReplace?: string | null;
}

export interface CartPrescriptionInputV2 {
  appointmentId?: string | null;
  documentId?: string | null;
  fileUrl?: string | null;
  meta?: PrescriptionMetaDataInput | null;
  prismFileId?: string | null;
  uhid?: string | null;
  isDelete?: boolean | null;
  hashedDocumentId?: string | null;
}

export interface CartSubscriptionInputV2 {
  circleAddedToCart?: boolean | null;
  planPurchaseDetails?: BasePlanDetails | null;
  subscriptionApplied?: boolean | null;
  userSubscriptionId?: string | null;
}

export interface CoordinateInput {
  latitude: number;
  longitude: number;
}

export interface PrescriptionMetaDataInput {
  createdAt?: string | null;
  doctorName?: string | null;
  fileName?: string | null;
  fileType?: string | null;
  medicineNames?: (string | null)[] | null;
  medicineSku?: (string | null)[] | null;
  patientName?: string | null;
}
export enum CART_TAG {
  COURIER = "COURIER",
  EXPRESS = "EXPRESS",
  INSTANT = "INSTANT",
  NEXT_DAY = "NEXT_DAY",
  SAME_DAY = "SAME_DAY",
}
export enum CartNudgeButtonAction {
  BREAK = "BREAK",
  CONTINUE = "CONTINUE",
}

export enum CartCtaAction {
  ADD_ADDRESS = "ADD_ADDRESS",
  DISABLED = "DISABLED",
  POPUP_DISMISS = "POPUP_DISMISS",
  PROCEED_TO_DELIVERY_OPTIONS = "PROCEED_TO_DELIVERY_OPTIONS",
  PROCEED_TO_PRESCRIPTIONS = "PROCEED_TO_PRESCRIPTIONS",
  REDIRECT_TO_DELIVERY_OPTION = "REDIRECT_TO_DELIVERY_OPTION",
  REMOVE_ITEMS = "REMOVE_ITEMS",
  SCROLL_TO_BREAKDOWN = "SCROLL_TO_BREAKDOWN",
  SELECT_ADDRESS = "SELECT_ADDRESS",
  SHOW_POPUP = "SHOW_POPUP",
  SHOW_PRESCRIPTION_UPLOAD_OPTIONS_POPUP = "SHOW_PRESCRIPTION_UPLOAD_OPTIONS_POPUP",
  SHOW_SAVE_PROFILE_POPUP = "SHOW_SAVE_PROFILE_POPUP",
}
export enum OPTIONS_KIND {
  FASTER_ALTERNATIVES = "FASTER_ALTERNATIVES",
  FASTER_REPLACEMENTS = "FASTER_REPLACEMENTS",
  FASTER_SUBTITUTES = "FASTER_SUBTITUTES",
  FASTER_VARIANTS = "FASTER_VARIANTS",
}
export enum ProductTag {
  FREEBIE = "FREEBIE",
  NEED_PRESCRIPTION = "NEED_PRESCRIPTION",
  OOS = "OOS",
  PRESCRIPTION_FOUND = "PRESCRIPTION_FOUND",
  SPECIAL_OFFER = "SPECIAL_OFFER",
}
export enum SHIPMENT_TYPE {
  COURIER = "COURIER",
  DEFAULT = "DEFAULT",
  EXPRESS = "EXPRESS",
  INSTANT = "INSTANT",
  NEXT_DAY = "NEXT_DAY",
  OOS = "OOS",
  SAME_DAY = "SAME_DAY",
}
export interface GuestCartInputDataV2 {
  address?: AddressInput | null;
  bankOffer?: boolean | null;
  cartSource?: CART_SOURCE | null;
  coupon?: string | null;
  feedback?: FEEDBACK | null;
  isHCPreferred?: boolean | null;
  isReminderSet?: boolean | null;
  medicineOrderCartLineItems?: (CartLineItemInputV2 | null)[] | null;
  id: any;
  prescriptionDetails?: (CartPrescriptionInputV2 | null)[] | null;
  prescriptionType?: PrescriptionType | null;
  subscription?: CartSubscriptionInputV2 | null;
  contactNumber?: string;
}

// move the import below inside redux folder

import { CartItem } from "@/redux/slice/cart/types/CartItem";

export interface Shipment {
  estimatedAmount?: number | null;
  orderTat?: string | null;
  isOutOfStockShipment?: boolean;
  items?: (CartItem | null)[] | null;
  shipmentNumber: number;
}